export interface TabItem {
  value: string
  label: string
  count?: number
}

export interface TabsProps {
  value: string
  tabs: TabItem[]
  onChange: (value: string) => void
  className?: string
  ariaLabel?: string
}

/** Accessible tab bar (roving selection with arrow keys). */
export function Tabs({ value, tabs, onChange, className = "", ariaLabel }: TabsProps) {
  const index = Math.max(0, tabs.findIndex((tab) => tab.value === value))

  return (
    <div className={`tabs ${className}`} role="tablist" aria-label={ariaLabel}>
      {tabs.map((tab, position) => (
        <button
          key={tab.value}
          type="button"
          role="tab"
          aria-selected={tab.value === value}
          className={`tab ${tab.value === value ? "tab-active" : ""}`}
          tabIndex={position === index ? 0 : -1}
          onClick={() => onChange(tab.value)}
          onKeyDown={(event) => {
            if (event.key !== "ArrowRight" && event.key !== "ArrowLeft") return
            event.preventDefault()
            const delta = event.key === "ArrowRight" ? 1 : -1
            const next = tabs[(position + delta + tabs.length) % tabs.length]
            onChange(next.value)
          }}
        >
          {tab.label}
          {typeof tab.count === "number" && tab.count > 0 && (
            <span className="tab-count">{tab.count}</span>
          )}
        </button>
      ))}
    </div>
  )
}
